function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 2.1C9.70617 2.1 11.9 4.2938 11.9 7C11.9 9.70617 9.70617 11.9 7 11.9C4.2938 11.9 2.1 9.70617 2.1 7C2.1 6.75398 2.11812 6.51234 2.15308 6.27617C2.20559 5.92142 1.94663 5.56667 1.57139 5.56667C1.27924 5.56667 1.01664 5.76922 0.970965 6.06669C0.92423 6.37103 0.9 6.6827 0.9 7C0.9 10.369 3.63106 13.1 7 13.1C10.369 13.1 13.1 10.369 13.1 7C13.1 3.63106 10.369 0.899999 7 0.899999C5.51691 0.899999 4.15725 1.42939 3.1 2.30938V0.833332C3.1 0.501964 2.83137 0.233332 2.5 0.233332C2.16863 0.233332 1.9 0.501964 1.9 0.833332V3.83333C1.9 4.1647 2.16863 4.43333 2.5 4.43333H5.5C5.83137 4.43333 6.1 4.1647 6.1 3.83333C6.1 3.50196 5.83137 3.23333 5.5 3.23333H3.86576C4.71532 2.52562 5.80785 2.1 7 2.1Z",
  strokeWidth: 0.2
});

var SvgRecordingRetake = function SvgRecordingRetake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecordingRetake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recording_retake.8924e2da.svg";
export { ForwardRef as ReactComponent };